/* eslint-disable no-unused-vars */
import React from 'react';
import HandleComponent from './Handle';
import BaseComponent from './Base.js';
import RelatedBaseComponent from './RelatedBase.js';
import ProngComponent from './Prong.js';
import {
  onlyChildNodeIsBetweenParents,
  isAtLeastOneChildRelated
} from '../../library/calc';
const assembleFork = ({union, nodeObjs, xHandlePos, startYOfHandle, endYOfHandle, unionIsRelated, sideYPoint, unionColor, stageBackgroundCustomColor}) => {
  const children = union.c;
  const ProngRelatedBaseComponents = children.map( (child) => {
    const nodeIsRelated = typeof(nodeObjs[child]['d_r']) !== 'undefined';
    const prongRelatedBaseArray = [<ProngComponent  key={child} {...{ child, nodeObjs, endYOfHandle, nodeIsRelated, unionColor, stageBackgroundCustomColor }} />];
    if((nodeIsRelated && children.length > 1 )||
       (nodeIsRelated && children.length === 1 && !onlyChildNodeIsBetweenParents( union, nodeObjs ))) {
      prongRelatedBaseArray.push(<RelatedBaseComponent {...{ child, nodeObjs, xHandlePos, endYOfHandle, stageBackgroundCustomColor}}/>);
    }
    return prongRelatedBaseArray;
  });

  // if(children.length === 1) {
  //   const onlyChildNodeObj = nodeObjs[children[0]];
  //   if(onlyChildNodeIsBetweenParents( union, nodeObjs ) ) {
  //     xHandlePos = onlyChildNodeObj.xCenter;
  //   }
  // }

  const atLeastOneChildRelated = isAtLeastOneChildRelated(children, nodeObjs);
  const ForkComponentsAssembledArrayOfOne = [
    <HandleComponent  key={Math.random()} {...{
      union,
      nodeObjs,
      xHandlePos,
      startYOfHandle,
      endYOfHandle,
      unionIsRelated,
      atLeastOneChildRelated,
      unionColor,
      stageBackgroundCustomColor
    }}/>,
    <BaseComponent  key={Math.random()}  {...{
      union,
      nodeObjs,
      xHandlePos,
      endYOfHandle,
      sideYPoint,
      unionColor,
      stageBackgroundCustomColor
    }}/>,
    ...ProngRelatedBaseComponents,
  ];
  return ForkComponentsAssembledArrayOfOne;
};


export default assembleFork;
